import api from '../api';

export const getListItemForm = async () => {
    const result = await api.get('/admin/itemForm');
    return result.data;
}

export const getOneItemForm = async (item) => {
    const result = await api.get(`/admin/itemForm/${item}`);
    return result.data;
}

export const addFieldForm = async (data, id) => {
    try {
        const response = await api.post(`/admin/field/item/new/${id}`, data);
        return JSON.stringify(response.data);
    } catch (error) {
        throw error;
    }
}



